var map = {
	"./level=01.png": 560,
	"./level=02.png": 8891,
	"./level=03.png": 4674,
	"./level=04.png": 7181,
	"./level=05.png": 7236,
	"./level=06.png": 1887,
	"./level=07.png": 5558,
	"./level=08.png": 3841,
	"./level=09.png": 9624,
	"./level=10.png": 3150,
	"./level=100.png": 3612,
	"./level=11.png": 6167,
	"./level=12.png": 5532,
	"./level=13.png": 4949,
	"./level=14.png": 282,
	"./level=15.png": 9139,
	"./level=16.png": 4648,
	"./level=17.png": 9265,
	"./level=18.png": 3110,
	"./level=19.png": 2127,
	"./level=20.png": 5151,
	"./level=21.png": 1862,
	"./level=22.png": 5837,
	"./level=23.png": 1940,
	"./level=24.png": 8184,
	"./level=25.png": 978,
	"./level=26.png": 1945,
	"./level=27.png": 3824,
	"./level=28.png": 7300,
	"./level=29.png": 6078,
	"./level=30.png": 4900,
	"./level=31.png": 6029,
	"./level=32.png": 8470,
	"./level=33.png": 15,
	"./level=34.png": 992,
	"./level=35.png": 7241,
	"./level=36.png": 4306,
	"./level=37.png": 4811,
	"./level=38.png": 3420,
	"./level=39.png": 9333,
	"./level=40.png": 3949,
	"./level=41.png": 2820,
	"./level=42.png": 5279,
	"./level=43.png": 6534,
	"./level=44.png": 5161,
	"./level=45.png": 9408,
	"./level=46.png": 7192,
	"./level=47.png": 1154,
	"./level=48.png": 2021,
	"./level=49.png": 4508,
	"./level=50.png": 1314,
	"./level=51.png": 2491,
	"./level=52.png": 4160,
	"./level=53.png": 2281,
	"./level=54.png": 2198,
	"./level=55.png": 5487,
	"./level=56.png": 2276,
	"./level=57.png": 6173,
	"./level=58.png": 8394,
	"./level=59.png": 2499,
	"./level=60.png": 6819,
	"./level=61.png": 5242,
	"./level=62.png": 9905,
	"./level=63.png": 9960,
	"./level=64.png": 5127,
	"./level=65.png": 3790,
	"./level=66.png": 9541,
	"./level=67.png": 6652,
	"./level=68.png": 6539,
	"./level=69.png": 7538,
	"./level=70.png": 9096,
	"./level=71.png": 225,
	"./level=72.png": 9642,
	"./level=73.png": 4851,
	"./level=74.png": 9980,
	"./level=75.png": 2869,
	"./level=76.png": 2510,
	"./level=77.png": 1735,
	"./level=78.png": 8176,
	"./level=79.png": 4425,
	"./level=80.png": 9601,
	"./level=81.png": 4984,
	"./level=82.png": 9475,
	"./level=83.png": 618,
	"./level=84.png": 5285,
	"./level=85.png": 5868,
	"./level=86.png": 6503,
	"./level=87.png": 3486,
	"./level=88.png": 6521,
	"./level=89.png": 9616,
	"./level=90.png": 7782,
	"./level=91.png": 6799,
	"./level=92.png": 2308,
	"./level=93.png": 8989,
	"./level=94.png": 1090,
	"./level=95.png": 2219,
	"./level=96.png": 928,
	"./level=97.png": 7177,
	"./level=98.png": 5262,
	"./level=99.png": 839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6418;